var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c("StepTitle", [_vm._v("Desactivadores")]),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "v-layout",
                    {
                      staticStyle: { "padding-right": "0px" },
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("BuscadorOperacionCrud", {
                              attrs: {
                                filter:
                                  _vm.gridApi &&
                                  _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c(
                        "v-flex",
                        {
                          staticStyle: { "padding-right": "0px" },
                          attrs: { xs12: "", sm6: "", md6: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-top": "6px",
                                "padding-right": "0px"
                              },
                              attrs: { align: "right" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "padding-right": "20px",
                                    display: "block",
                                    margin: "0 0 0 auto"
                                  },
                                  attrs: { color: "#ffe800" },
                                  on: { click: _vm.crear_estado }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { dark: "", left: "" }
                                    },
                                    [_vm._v("add_circle_outline")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "black" } },
                                    [_vm._v("Crear Estado")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("MantenedorGrid", {
                        attrs: { "grid-options": _vm.gridOptions }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c("div", { staticClass: "ModalEdit" }, [
              _c(
                "div",
                {
                  staticClass: "modalEnvio-content",
                  attrs: { id: "desactivadores" }
                },
                [
                  _c("div", [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeReporte()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("close")]
                            ),
                            _vm._v("  \n                "),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Cerrar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { attrs: { align: "center" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    staticClass: "col-md-12",
                                    attrs: { "lazy-validation": "" }
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticStyle: {
                                          padding: "30px 40px 50px 40px"
                                        },
                                        attrs: { "grid-list-md": "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "boton_crear" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "icon",
                                                staticStyle: {
                                                  "background-color":
                                                    "rgb(255, 108, 0)",
                                                  "border-color":
                                                    "rgb(255, 108, 0)",
                                                  "padding-right": "20px",
                                                  display: "block",
                                                  margin: "0 0 0 auto"
                                                },
                                                on: { click: _vm.guardar }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Guardar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "FormFieldsContainer",
                                          {
                                            attrs: {
                                              titulo: "Cambio de Estado"
                                            }
                                          },
                                          [
                                            _vm._t("prependInformacionGeneral"),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields
                                                        .fechadesactivacion
                                                        .label,
                                                    disabled: _vm.modoVer
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields
                                                        .fechadesactivacion
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields
                                                          .fechadesactivacion,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.fechadesactivacion.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.nota.label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.nota.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.nota,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.nota.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.usuario
                                                        .label,
                                                    disabled: _vm.modoVer
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.usuario
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.usuario,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.usuario.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: { sm4: "", md4: "" }
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.simestado
                                                        .label,
                                                    items: _vm.simestadolist,
                                                    "item-text": "configvalor",
                                                    "item-value": "configvalor"
                                                  },
                                                  on: {
                                                    change: _vm.getconfigOptions
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.simestado
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields
                                                          .simestado,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.simestado.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: { sm4: "", md4: "" }
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.motivos
                                                        .label,
                                                    items: _vm.motivos,
                                                    "item-text": "motiname",
                                                    "item-value": "motiid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.motivos
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.motivos,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.motivos.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Cambio de Estado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }